import { useQueryClient } from "@tanstack/react-query";

import { engagementsKeys } from "./query_keys";

export const useEngagementsInvalidate = () => {
  const queryClient = useQueryClient();

  return {
    invalidateAll: () => {
      queryClient.invalidateQueries({ queryKey: engagementsKeys.all() });
    }
  };
};
